import { render, staticRenderFns } from "./van-popup-stockInfo-bly.vue?vue&type=template&id=a7a35c60&scoped=true"
import script from "./van-popup-stockInfo-bly.vue?vue&type=script&setup=true&lang=js"
export * from "./van-popup-stockInfo-bly.vue?vue&type=script&setup=true&lang=js"
import style0 from "./van-popup-stockInfo-bly.vue?vue&type=style&index=0&id=a7a35c60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a35c60",
  null
  
)

export default component.exports